import { produce } from 'immer';
import {
  SCORM_CATEGORIES_GET,
  SCORM_DETAILS_GET,
  SCORM_DETAILS_RESET,
  SCORM_LIST_GET,
} from '../actions/scorm';
import { AUTH_LOGOUT } from '../actions';

const initialState = {
  categories: [],
  filters: {},
  list: [],
  pager: {},
  details: {},
};

const publicReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case SCORM_CATEGORIES_GET._SUCCESS: {
        const { response } = action;
        draft.categories = response || [];
        break;
      }

      case SCORM_LIST_GET._SUCCESS: {
        draft.list = action.response?.items || [];
        draft.pager = action?.pager || {};
        break;
      }

      case SCORM_DETAILS_GET._SUCCESS: {
        draft.details = action?.response || {};
        break;
      }

      case SCORM_DETAILS_RESET: {
        draft.details = initialState.details;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default publicReducer;
